export const CONDITIONS = [
  { id: 'price_above', label: 'Price crosses above', unit: '$' },
  { id: 'price_below', label: 'Price drops below', unit: '$' },
  { id: 'pct_gain_above', label: 'Daily gain exceeds', unit: '%' },
  { id: 'pct_drop_below', label: 'Daily drop exceeds', unit: '%' },
  { id: 'pct_change_above', label: 'Daily |change %| exceeds', unit: '%' },
];
